import { Box } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import Chart from 'react-apexcharts'
import { ButtonSort } from 'src/components/ButtonSort'
import locales from '../chartLocales'
import { ChartSkeleton } from '../components/ChartSkeleton'
import dashboardStore from './store'

function GraficoCaminhoesPorCliente() {
  const [isAscendingQtd, setIsAscendingQtd] = useState<boolean>(false)
  const [isAscendingDescription, setIsAscendingDescription] =
    useState<boolean>(false)
  const { categories, series } = dashboardStore.graficoCaminhoesPorCentroCusto

  const options: ApexCharts.ApexOptions = {
    chart: {
      id: 'caminhoes-centrocusto',
      defaultLocale: 'pt',
      locales,
      toolbar: {
        export: {
          csv: {
            headerCategory: 'Categoria'
          }
        }
      }
    },
    colors: ['#632336'],
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true
      }
    },
    xaxis: { categories },
    title: {
      text: 'Quantidade de Caminhões por Centro de Custo',
      align: 'center',
      style: {
        fontFamily: 'Gilroy',
        fontWeight: 'normal',
        fontSize: '16px'
      }
    }
  }

  function handleSortQtd() {
    dashboardStore.sortDataCaminhoesCentroCustoPerQtd(isAscendingQtd)
    setIsAscendingQtd(isAscendingQtd => !isAscendingQtd)
  }

  function handleSortDescription() {
    dashboardStore.sortDataCaminhoesCentroCustoPerDescription(
      isAscendingDescription
    )
    setIsAscendingDescription(isAscendingDescription => !isAscendingDescription)
  }

  const chartLength =
    categories.length && categories.length > 10 ? categories.length * 30 : 495

  return (
    <>
      {dashboardStore.loading ? (
        <ChartSkeleton
          rows={22}
          title="Quantidade de Caminhões por Centro de Custo"
        />
      ) : (
        <>
          <Box
            display="flex"
            justifyContent="flex-end"
            position="absolute"
            zIndex={2}
          >
            <ButtonSort
              textSortName="Ordenar por centro de custo"
              textSortQuantity="Ordernar por quantidade"
              sortName={handleSortDescription}
              sortQuantity={handleSortQtd}
            />
          </Box>
          <div
            style={{
              overflow: 'auto',
              height: '512px'
            }}
          >
            <Chart
              options={options}
              series={series}
              type="bar"
              width="100%"
              height={chartLength}
            />
          </div>
        </>
      )}
    </>
  )
}

export default observer(GraficoCaminhoesPorCliente)
